// @ts-nocheck
import React, { useEffect, useState, useRef } from "react";
import { Flex, Button, Menu, Layout, Result, FloatButton, ConfigProvider, Affix, Tabs, Space, Table, Tag, InputNumber, Input, ColorPicker, Tree, Col, Row, Slider } from 'antd';
import ReactPDF, { BlobProvider, Document, Page, Text, View, StyleSheet, Svg, PDFViewer, pdf, usePDF, PDFDownloadLink, Rect, Circle, G, Path, Image } from '@react-pdf/renderer';

export function Etiqueta01() {

	return (
		<svg width="200" height="100" xmlns="http://www.w3.org/2000/svg">
			<rect width="200" height="100" x="0" y="0" fill="white" strokeWidth="1" stroke="black" />
			<rect width="190" height="35" x="5" y="5" fill="white" strokeWidth="1" stroke="black" />
			<rect width="190" height="50" x="5" y="45" fill="white" strokeWidth="1" stroke="black" />
			<text x="100" y="25" fill="black" textAnchor="middle">Product 01</text>
			<text x="100" y="75" fill="black" textAnchor="middle">$ 5.99</text>
		</svg>
	);

};

export function Etiqueta02() {

	return (
		<svg width="200" height="100" xmlns="http://www.w3.org/2000/svg">
			<rect width="200" height="100" x="0" y="0" fill="white" strokeWidth="1" stroke="red" />
			<rect width="190" height="35" x="5" y="5" fill="white" strokeWidth="1" stroke="red" />
			<rect width="190" height="50" x="5" y="45" fill="white" strokeWidth="1" stroke="red" />
			<text x="100" y="25" fill="red" textAnchor="middle">Product 02</text>
			<svg x="75" y="45" height="50" width="50" viewBox="0 0 25 25" role="img"><path fill="transparent" d="M0,0 h25v25H0z" shapeRendering="crispEdges"></path><path fill="rgba(0, 0, 0, 0.88)" d="M0 0h7v1H0zM8 0h2v1H8zM11 0h5v1H11zM18,0 h7v1H18zM0 1h1v1H0zM6 1h1v1H6zM10 1h6v1H10zM18 1h1v1H18zM24,1 h1v1H24zM0 2h1v1H0zM2 2h3v1H2zM6 2h1v1H6zM8 2h1v1H8zM10 2h1v1H10zM12 2h1v1H12zM15 2h1v1H15zM18 2h1v1H18zM20 2h3v1H20zM24,2 h1v1H24zM0 3h1v1H0zM2 3h3v1H2zM6 3h1v1H6zM8 3h2v1H8zM15 3h1v1H15zM18 3h1v1H18zM20 3h3v1H20zM24,3 h1v1H24zM0 4h1v1H0zM2 4h3v1H2zM6 4h1v1H6zM10 4h1v1H10zM12 4h1v1H12zM14 4h3v1H14zM18 4h1v1H18zM20 4h3v1H20zM24,4 h1v1H24zM0 5h1v1H0zM6 5h1v1H6zM8 5h1v1H8zM11 5h1v1H11zM15 5h2v1H15zM18 5h1v1H18zM24,5 h1v1H24zM0 6h7v1H0zM8 6h1v1H8zM10 6h1v1H10zM12 6h1v1H12zM14 6h1v1H14zM16 6h1v1H16zM18,6 h7v1H18zM8 7h1v1H8zM14 7h3v1H14zM1 8h1v1H1zM3 8h1v1H3zM5 8h8v1H5zM15 8h5v1H15zM21 8h2v1H21zM24,8 h1v1H24zM0 9h3v1H0zM7 9h1v1H7zM9 9h2v1H9zM16 9h3v1H16zM24,9 h1v1H24zM4 10h1v1H4zM6 10h2v1H6zM16 10h2v1H16zM20 10h1v1H20zM23,10 h2v1H23zM0 11h1v1H0zM2 11h2v1H2zM8 11h1v1H8zM11 11h2v1H11zM14 11h1v1H14zM18 11h3v1H18zM0 12h2v1H0zM4 12h4v1H4zM10 12h3v1H10zM17 12h2v1H17zM21 12h1v1H21zM23,12 h2v1H23zM1 13h2v1H1zM5 13h1v1H5zM7 13h1v1H7zM9 13h1v1H9zM11 13h1v1H11zM18 13h2v1H18zM21 13h2v1H21zM24,13 h1v1H24zM0 14h1v1H0zM2 14h2v1H2zM6 14h2v1H6zM9 14h1v1H9zM11 14h1v1H11zM18 14h3v1H18zM22 14h1v1H22zM24,14 h1v1H24zM1 15h1v1H1zM3 15h3v1H3zM7 15h1v1H7zM9 15h2v1H9zM13 15h1v1H13zM15 15h3v1H15zM20 15h1v1H20zM23 15h1v1H23zM0 16h3v1H0zM4 16h1v1H4zM6 16h1v1H6zM9 16h1v1H9zM12 16h1v1H12zM14 16h1v1H14zM16 16h7v1H16zM8 17h1v1H8zM10 17h1v1H10zM12 17h5v1H12zM20 17h2v1H20zM24,17 h1v1H24zM0 18h7v1H0zM8 18h3v1H8zM14 18h3v1H14zM18 18h1v1H18zM20 18h2v1H20zM23,18 h2v1H23zM0 19h1v1H0zM6 19h1v1H6zM8 19h2v1H8zM13 19h1v1H13zM16 19h1v1H16zM20 19h3v1H20zM24,19 h1v1H24zM0 20h1v1H0zM2 20h3v1H2zM6 20h1v1H6zM9 20h1v1H9zM11 20h3v1H11zM16 20h6v1H16zM23,20 h2v1H23zM0 21h1v1H0zM2 21h3v1H2zM6 21h1v1H6zM8 21h2v1H8zM11 21h1v1H11zM15 21h1v1H15zM17 21h1v1H17zM19 21h4v1H19zM0 22h1v1H0zM2 22h3v1H2zM6 22h1v1H6zM9 22h5v1H9zM15 22h1v1H15zM19 22h2v1H19zM22 22h1v1H22zM24,22 h1v1H24zM0 23h1v1H0zM6 23h1v1H6zM8 23h1v1H8zM10 23h1v1H10zM13 23h1v1H13zM15 23h4v1H15zM21 23h1v1H21zM0 24h7v1H0zM14 24h3v1H14zM19 24h1v1H19zM23,24 h2v1H23z" shapeRendering="crispEdges"></path></svg>
		</svg>
	);

};

export function Etiqueta03() {

	return (
		<svg id="SVG001" name="SVG001" width="200" height="100" xmlns="http://www.w3.org/2000/svg">
			<rect width="200" height="100" x="0" y="0" fill="white" strokeWidth="1" stroke="blue" />
			<rect width="190" height="35" x="5" y="5" fill="white" strokeWidth="1" stroke="blue" />
			<rect width="190" height="50" x="5" y="45" fill="white" strokeWidth="1" stroke="blue" />
			<text x="100" y="25" fill="blue" textAnchor="middle">Product 03</text>
			<text x="100" y="70" fill="blue" textAnchor="middle" fontSize="35" alignmentBaseline="central">$ 5.99</text>
		</svg>
	);

};

const SvgComponent = ({ svgNodes }) => {
	const [svgNodesSt, setSvgNodesSt] = useState(svgNodes);

	useEffect(() => {
          setSvgNodesSt(svgNodes)        
     }, [svgNodes]);
	// return (
	// 	<div>
	// 		{svgNodes && <svg>{Array.from(svgNodes.childNodes).map((node, index) => (
	// 			<React.Fragment key={index}>{node.outerHTML}</React.Fragment>
	// 		))}</svg>}
	// 	</div>
	// );


	const renderNode = (node) => {
		// Se o nó for um elemento, renderiza como um elemento React

		if (node.nodeType === Node.ELEMENT_NODE) {

			const children = Array.from(node.childNodes).map(renderNode); // Renderiza os filhos recursivamente
			const attributes = Array.from(node.attributes).reduce((attrs, attr) => {
				// attrs[attr.name] = attr.value; // Converte atributos para um objeto
				// return attrs;

				const name = attr.name;
				const value = attr.value;
	   
				// Converte atributos SVG para camelCase
				const camelCasedName = name.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
				attrs[camelCasedName] = value;
	   
				return attrs;

			}, {});

			// Se o nó for um elemento <text>, adiciona o innerText como filho
			if (node.nodeName.toLowerCase() === 'text') {
				return React.createElement(node.nodeName.toLowerCase(), attributes, node.innerText, ...children);
			}

			return React.createElement(node.nodeName.toLowerCase(), attributes, ...children);
		} else if (node.nodeType === Node.TEXT_NODE) {

			// Se o nó for um texto, retorna o texto
			return node.nodeValue; // Retorna o texto contido no nó
		}
		return null; // Ignora outros tipos de nós
	};

	return (
		<div>
			{svgNodesSt && renderNode(svgNodesSt)}
		</div>
	);
};



export default SvgComponent;


